export default class InstagramWidget {
  constructor(section) {
    this.$el = $(section.el);
    this.initializedClass = 'instagram-initialized';
    this._validate();
  }

  _validate() {
    this.$photoContainer = $('[data-instagram-photos]', this.$el);
    const accessToken = $('[data-instagram-token]', this.$el).attr('data-instagram-token');
    const photoCount = $('[data-instagram-photo-count]', this.$el).attr('data-instagram-photo-count');
    const isInitialized = this.$el.hasClass(this.initializedClass);

    return this._getPhotos(accessToken, photoCount, isInitialized);
  }

  _getPhotos(accessToken, photoCount, isInitialized) {
    if (!accessToken.length) { return this._hasError(false); }
    if (isInitialized) { return; }

    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${accessToken}&count=${photoCount}&callback=`;

    return $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url,

      success: (response) => {
        if (response.meta.code === 200) {
          this.$photoContainer.empty();

          const result = [];
          for (let i = 0; i < response.data.length; i++) {
            const photo = response.data[i];
            if (photo && photo.images
              && photo.images.standard_resolution
              && photo.images.standard_resolution.url) {
              result.push(this.$photoContainer.append(
                `\
                <a
                class="instagram-photo"
                target="_blank"
                href="${photo.link}"
                style="background-image: url('${photo.images.standard_resolution.url}')"
                >
                </a>\
                `,
              ));
            }
          }
          return result;
        }
        this.$photoContainer.append(`<div class='instagram-error'>Instagram error: ${response.meta.error_message}</div>`);
        return console.log(`Instagram error: ${response.meta.error_message}`);
      },

      error: (response) => {
        this.$photoContainer.empty();
        return console.log(`Instagram error: ${response.meta.error_message}`);
      },
    });
  }


  _hasError(response) {
    this.$el.toggleClass(this.initializedClass, false);

    if (response) { return console.log(`Instagram error: ${response.meta.error_message}`); }
  }

  update() {
    this._validate();
  }
}
